/* eslint-disable @typescript-eslint/indent */
import { useMutation } from '@apollo/client';

import { qualityDeleteReturnReceiptMutation } from './gql';
import { IMutationResult, IDeleteReturnReceiptVariables } from './interfaces';

export const useQualityDeleteReturnReceiptGql = () => {
  const [runQualityDeleteReturnReceiptMutation, { data, loading, error }] = useMutation<
    IMutationResult,
    IDeleteReturnReceiptVariables
  >(qualityDeleteReturnReceiptMutation, {
    context: {
      headers: {
        userFunctionKey: 'a684eceee76fc522773286a895bc8436'
      }
    }
  });

  return {
    runQualityDeleteReturnReceiptMutation,
    loadingQualityDeleteReturnReceipt: loading,
    message: data?.message || '',
    errorQualityDeleteReturnReceipt: error
  };
};
